import React from 'react';

import { isMobileScreen } from '../../services';
import AdDetailsPageMobile from './AdDetailsPageMobile';
import AdDetailsPageWeb from './AdDetailsPageWeb';
import getWidthContext from '../../HOCs/getWidthContext';

interface AdDetailsPageProps {
  history?: History;
  location?: Location;
  match?: { path: string; url: string; isExact: boolean; params: {} };
  staticContext?: any;
  width?: number;
}

const AdDetailsPage = (props:AdDetailsPageProps) => (
  <React.Fragment>
    {isMobileScreen(props.width) ? <AdDetailsPageMobile {...props} /> : <AdDetailsPageWeb {...props} />}
  </React.Fragment>
);

export default getWidthContext(AdDetailsPage);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/index.tsx